// extracted by mini-css-extract-plugin
export default {"greenBorder":"greenBorder--j04wE"};